export default __webpack_public_path__ + "static/media/clock-orange.a42579d5.svg";